import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';

const resources = {
  en: {
    translation: translationEN
  },
  es: {
    translation: translationES
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    // Idioma por defecto: inglés. No se define `lng` a propósito, porque al
    // fijarlo i18next omite el detector y la elección del selector de idioma
    // se perdería en cada recarga.
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    load: 'languageOnly', // es-MX / en-US -> es / en

    // Solo localStorage: el idioma del navegador no debe sobreescribir el
    // inglés por defecto. Lo que el usuario elija en el selector sí persiste.
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false // React ya hace escape de XSS
    },

    debug: process.env.NODE_ENV === 'development'
  });

export default i18n; 